import { Link } from 'react-router-dom';
import { DashboardLayout } from 'layouts/DashboardLayout';

export const NoPermission = () => {
  return (
    <DashboardLayout>
      {' '}
      <main className="flex-grow mx-auto max-w-7xl w-full flex flex-col px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 my-auto py-16 sm:py-32">
          <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide">
            Permission Denied
          </p>
          <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
            You don't have permission to view that
          </h1>
          <p className="mt-2 text-base text-gray-500">
            Sorry, but your account does not have permission to view that.
          </p>
          <div className="mt-6">
            <Link
              to="/dashboard"
              className="text-base font-medium text-blue-600 hover:text-blue-500"
            >
              Go back home<span aria-hidden="true"> &rarr;</span>
            </Link>
          </div>
        </div>
      </main>
    </DashboardLayout>
  );
};
